<template>
    <ns-paginate
        ref="nsPaginate"
        baseUrl='importable-motor/'
        :customFiltersToApply="customFiltersToApply"
        :displayCsvButton="false"
        class="import-motor-paginate"
    >
        <template slot="list" slot-scope="props">
            <div
                v-if="props.list.length > 0"
                class="import-motor__content"
            >
                <div
                    v-for="(motor, index) in props.list"
                    :key="index"
                >
                    <el-card class="import-motor__content__card">
                        <div class="import-motor__content__card__container">
                            <div>
                                <span>{{ motor.name }}</span>
                                <span
                                    class="import-motor__content__card__container__imported-from"
                                    :style="{ background: getColor(motor.imported_from) }"
                                >
                                    {{ motor.imported_from }}
                                </span>
                            </div>
                            <div>
                                <el-button
                                    type="info"
                                    circle
                                    icon="el-icon-download"
                                    class="import-motor__content__card__container__import-btn"
                                    @click="importMotor(motor)"
                                ></el-button>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
            <div v-else>
                {{ getText('audit_no_importable_motors_by_site') }} <strong>{{ siteName }}</strong>
            </div>
        </template>
    </ns-paginate>
</template>

<script>
import { mapGetters } from 'vuex';
import NsPaginate from 'fundation-app-vuejs/src/components/partials/nsPaginate';
export default {

    name: 'importMotorModal',

    components:{
        NsPaginate
    },

    props: {
        siteName:{
            type: String,
            required: true,
        }
    },

    data () {
        return {
        };
    },

    computed:{
        ...mapGetters([
            'getText',
            'currentUser',
        ]),
        customFiltersToApply() {
            return () => {
                return {
                    archived: false,
                    user_uid: this.currentUser.uid,
                    site_name: this.siteName,
                }
            }
        },
    },

    methods:{
        importMotor(importableMotor){
            this.$store.commit('SET_IMPORTABLE_DATA', importableMotor);
            this.$router.push({
                name: 'moteur',
                params: { siteid: this.$route.params.siteid }
            });
        },
        getColor(motorImportedFrom){
            if(motorImportedFrom === 'MotorView'){
                return '#27316D';
            } else {
                return '#FE5612';
            }
        }
    }
};
</script>

<style lang="scss">
.import-motor-dialog{
    .el-dialog__title{
        margin-left: 0.5rem;
    }
}
.import-motor{
    &__content{
        max-height: 300px;
        overflow-y: auto;
        &__card{
            margin-top: 1rem;
            &__container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                &__imported-from{
                    font-size: 12px;
                    margin-left: 2rem;
                    padding: 0.5rem 1rem;
                    border-radius: 3rem;
                    color: white;
                }
                &__import-btn:hover{
                    border-color: #C4D600;
                    background-color: #C4D600;
                    color: white;
                }
            }
        }
    }
}
.ns-paginate.import-motor-paginate{
    .reloadBtn{
        display: none;
    }
    .blockSearch{
        span{
            display: none;
        }
    }
    .blockFlex{
        .el-button.el-button--primary{
            border: none;
            background-color: #C4D600;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page/import-motor-modal/motorsModal.vue